import React from 'react';

export default function ArticleBlock({ block, fallbackAlt }) {
  if (block.type === 'h2') {
    return <h2 className="font-display text-[#f4efe6] uppercase text-2xl md:text-3xl tracking-tight mt-12 mb-5">{block.text}</h2>;
  }
  if (block.type === 'h3') {
    return <h3 className="font-display text-[#f4efe6] uppercase text-xl md:text-2xl tracking-tight mt-10 mb-4">{block.text}</h3>;
  }
  if (block.type === 'ul') {
    return (
      <ul className="list-disc list-outside pl-5 my-6 space-y-2 marker:text-[#00b8ff]">
        {block.items.map((it, i) => <li key={`${i}-${it}`}>{it}</li>)}
      </ul>
    );
  }
  if (block.type === 'img') {
    return (
      <figure className="my-10" data-testid="article-figure">
        <img
          src={block.src}
          alt={block.alt || block.caption || fallbackAlt}
          width={block.width}
          height={block.height}
          loading="lazy"
          decoding="async"
          className="w-full h-auto rounded-md"
        />
        {block.caption && (
          <figcaption className="mt-3 text-sm text-[#8a8478] border-l-2 border-[#00b8ff] pl-3">{block.caption}</figcaption>
        )}
      </figure>
    );
  }
  return <p className="my-5">{block.text}</p>;
}
